import { prefersReducedMotion } from "../siteKit/motion/reducedMotion";

/** 검색으로 간 절은 도착하자마자 잠깐 옅은 파랑으로 짚어 준다 */
const ARRIVAL_FLASH: Keyframe[] = [
  { background: "rgba(29,116,255,.08)" },
  { background: "transparent" },
];
const ARRIVAL_FLASH_TIMING: KeyframeAnimationOptions = {
  duration: 1600,
  easing: "ease-out",
};

/**
 * 매뉴얼 안 장·절로 바로 이동(service-manual — 사이 내용을 부드러운 스크롤로 지나가지 않는다). 도착 자리는 장·절의
 * `scroll-margin-top` 이 정한다. 링크 기본 이동을 막고 옮기므로, 키보드 사용자가 그 자리에서 Tab 을 이어 가도록 초점도
 * 옮긴다(장·절은 `tabIndex=-1`).
 */
export function jumpToManualSection(
  id: string,
  { flash = false }: { flash?: boolean } = {}
) {
  const target = document.getElementById(id);
  if (!target) return;
  // behavior 를 주지 않는다 — 기본값(auto)은 루트의 CSS scroll-behavior 를 따르고, 사이트는 smooth 를 두지 않아 곧 바로 이동이다
  target.scrollIntoView({ block: "start" });
  target.focus({ preventScroll: true });
  if (
    flash &&
    !prefersReducedMotion() &&
    typeof target.animate === "function"
  ) {
    target.animate(ARRIVAL_FLASH, ARRIVAL_FLASH_TIMING);
  }
}

/** 절 안내 플레이어의 시작 단계(1부터)를 싣는 쿼리 이름 — `/manual?step=N#<절>` */
export const MANUAL_STEP_QUERY = "step";

/**
 * 매뉴얼 절 주소 `/manual#<절>` — `step`(1부터)을 주면 그 절의 안내 플레이어가 그 단계부터 열리는 `/manual?step=N#<절>`.
 * 주소를 읽는 쪽은 `guideStartStepFromLocation`(시작 단계)과 손님 안내(절 주소로 왔는지)다.
 */
export function manualTopicHref(topic: string, step?: number): string {
  const query = step ? `?${MANUAL_STEP_QUERY}=${step}` : "";
  return `/manual${query}#${topic}`;
}

/** 매뉴얼 맨 위로 바로 이동(「처음으로」·「맨 위로」) */
export function scrollToManualTop() {
  window.scrollTo({ top: 0 });
}

/**
 * `/manual?step=N#<절>` 로 연 절의 안내 플레이어가 처음 보여 줄 단계(0부터) — 업데이트 소식의 「시연 영상 보기」가
 * 그 기능이 나오는 단계부터 열 때 쓴다. 그 절의 주소가 아니거나 N 이 1~단계 수 밖이면 첫 단계.
 */
export function guideStartStepFromLocation(
  guideKey: string,
  stepCount: number,
  location: { hash: string; search: string } = window.location
): number {
  if (location.hash !== `#${guideKey}`) return 0;
  const step = Number(
    new URLSearchParams(location.search).get(MANUAL_STEP_QUERY)
  );
  const isStepInRange =
    Number.isInteger(step) && step >= 1 && step <= stepCount;
  return isStepInRange ? step - 1 : 0;
}
